

export abstract class Constants {
    static readonly SWEET_ALERT_PROPERTIES ={ title: '',
    text: '',
    type: null,
    allowOutsideClick: false,
    showConfirmButton: true,
    showCancelButton: false,
    closeOnConfirm: true,
    closeOnCancel: true,
    confirmButtonText: 'Aceptar',
    confirmButtonColor:'#004c97',
    cancelButtonText: 'Cancelar',
    cancelButtonColor: '#6c757d',
    imageUrl: null,
    imageSize: null,
    timer: null,
    customClass: '',
    html: false,
    animation: true,
    allowEscapeKey: true,
    inputType: 'text',
    inputPlaceholder: '',
    inputValue: '',
    showLoaderOnConfirm: false
    }

}